import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314335fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/carrinho_compras.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Carrinho de Compras ")
const _hoisted_3 = { class: "font-montserrat font-15" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-montserrat font-20" }, " Carrinho Vazio", -1))
const _hoisted_5 = { class: "font-montserrat font-15" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "promo_msg",
  size: "6"
}, "Você Ganhou", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "promo_detail",
  size: "6"
}, "Frete Grátis", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Excluir ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Remover ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Limpar ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Salvar ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Subtotal", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Voltar")
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  color: "danger",
  shape: "round"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Carrinho Vazio")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cartItemNumber) + " Itens", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.cartItemNumber==0)
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_badge, { color: "danger" }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carts, (categorias, index) => {
            return (_openBlock(), _createBlock(_component_ion_list, {
              key: index,
              class: "ion-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item_divider, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(categorias[0].primary_category_root_name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carts_product(categorias), (product, index_prod) => {
                      return (_openBlock(), _createBlock(_component_ion_item, { key: index_prod }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_avatar, {
                            slot: "start",
                            onClick: ($event: any) => (_ctx.goProduto(product))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: product.image
                              }, null, 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, { class: "ion-align-items-center ion-no-padding" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    onClick: ($event: any) => (_ctx.goProduto(product)),
                                    size: "12",
                                    class: "ion-align-items-center ion-no-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(product.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_ion_col, {
                                    onClick: ($event: any) => (_ctx.goProduto(product)),
                                    size: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      (product.loading)
                                        ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                                        : _createCommentVNode("", true),
                                      (product.frete_gratis)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_10))
                                        : _createCommentVNode("", true),
                                      (product.loading != true && product.price_adjustments)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 2,
                                            class: _normalizeClass(product.price_adjustments ? 'promo' : 'nopromo')
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$cart.currencyUSD(product.price)), 1),
                                            _hoisted_11,
                                            _createElementVNode("span", null, _toDisplayString(product.price_adjustments ? _ctx.$cart.currencyUSD(product.price_after_item_discount): ''), 1)
                                          ], 2))
                                        : (_openBlock(), _createElementBlock("p", {
                                            key: 3,
                                            class: _normalizeClass(product.price_from ? 'promo_from' : 'nopromo')
                                          }, [
                                            (product.price_from)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                  _createTextVNode(_toDisplayString(product.price_from ? _ctx.$cart.currencyUSD(product.price_from) : '') + " ", 1),
                                                  _hoisted_13
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$cart.currencyUSD(product.price)), 1)
                                          ], 2))
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_ion_col, {
                                    size: "6",
                                    class: "ion-align-items-center ion-no-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      (product.quantity > 0)
                                        ? (_openBlock(), _createBlock(_component_ion_row, {
                                            key: 0,
                                            class: "ion-align-items-center bottoes_acao_layout"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_col, {
                                                size: "4",
                                                onClick: ($event: any) => (_ctx.$cart.doAddMainMinus(product)),
                                                class: "ion-text-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    color: "jauservelayoutalter",
                                                    icon: product.quantity == 1 ? _ctx.trashOutline: _ctx.removeCircleOutline
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_ion_col, {
                                                size: "4",
                                                class: "ion-text-center text_layout_center"
                                              }, {
                                                default: _withCtx(() => [
                                                  (product.loading)
                                                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                                        key: 0,
                                                        class: "text_layout"
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  _hoisted_14,
                                                  (product.loading!=true)
                                                    ? (_openBlock(), _createBlock(_component_ion_row, {
                                                        key: 1,
                                                        class: "text_layout"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(product.quantity), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_col, {
                                                size: "4",
                                                onClick: ($event: any) => (_ctx.$cart.doAddMainPlus(product)),
                                                class: "ion-text-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    color: "jauservelayoutalter",
                                                    icon: _ctx.addCircleOutline
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              (product.removed)
                                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                                    key: 0,
                                                    size: "12",
                                                    onClick: ($event: any) => (_ctx.$cart.doSetCartRemove(product)),
                                                    class: "ion-text-center no-padding"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_button, {
                                                        class: "ion-button-remove",
                                                        size: "small",
                                                        expand: "block",
                                                        color: "jauservelayoutciza6"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _hoisted_15
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_button, {
                                                onClick: ($event: any) => (_ctx.$cart.doAddMainMinus(product)),
                                                color: "danger",
                                                fill: "clear"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: _ctx.trashOutline
                                                  }, null, 8, ["icon"]),
                                                  _hoisted_16
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "3",
                class: "ion-text-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    class: "ion-button",
                    shape: "jau",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearCart())),
                    size: "small",
                    expand: "block",
                    color: "jauservelayoutciza6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      (_ctx.onClear)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "3",
                class: "ion-text-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    class: "ion-button",
                    shape: "jau",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveCart())),
                    size: "small",
                    expand: "block",
                    color: "jauservelayoutalter"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18,
                      (_ctx.onSave)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                class: "text-subtotal"
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.$cart.currencyUSD(_ctx.cartTotal)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "5",
                class: "ion-text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    class: "ion-button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.voltar())),
                    size: "small",
                    shape: "jau",
                    expand: "block",
                    color: "jauservelayoutciza6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "2",
                class: "ion-text-center"
              }),
              _createVNode(_component_ion_col, {
                size: "5",
                class: "ion-text-center"
              }, {
                default: _withCtx(() => [
                  (_ctx.cartItemNumber > 0)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        class: "ion-button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('/checkout'))),
                        size: "small",
                        expand: "block",
                        shape: "jau",
                        color: "jauservelayoutalter",
                        disabled: _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                _createVNode(_component_ion_spinner, { name: "circular" })
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, " Finalização ")),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.chevronForward
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_openBlock(), _createBlock(_component_ion_button, {
                        key: 1,
                        class: "ion-button",
                        size: "small",
                        shape: "jau",
                        expand: "block",
                        color: "jauservelayoutalter"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}